// import React from 'react'
// import { useAuth } from '../../context/Auth'
// import styles from './Manager.module.css'
// const ActiveDropDown = ({ tab, onSelect }) => {
//     const { mode } = useAuth();

//     return (
//         <div className={styles.StatusComtiner}
//             style={{ backgroundColor: mode ? "#232530" : "#fff" }} >
//             {tab.map((e) =>
//                 <div
//                     className={mode ? styles.ststusHover_dark : styles.ststusHove_light}
//                     onClick={() => onSelect(e)}
//                 >
//                     {e?.name}
//                 </div>
//             )}
//         </div>
//     )
// }

// export default ActiveDropDown


import React, { useEffect, useRef } from 'react';
import { useAuth } from '../../context/Auth';
import styles from './Manager.module.css';

const ActiveDropDown = ({ tab, onSelect, onClose }) => {
    const { mode } = useAuth();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose(); // Call parent function to close dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    return (
        <div
            ref={dropdownRef}
            className={styles.StatusComtiner}
            style={{ backgroundColor: mode ? "#232530" : "#fff" }}
        >
            {tab.map((e, index) => (
                <div
                    key={index}
                    className={mode ? styles.ststusHover_dark : styles.ststusHove_light}
                    onClick={() => onSelect(e)}
                >
                    {e?.name}
                </div>
            ))}
        </div>
    );
};

export default ActiveDropDown;
